import React, { useEffect, useRef } from 'react';
import './footer.css';
import gsap from 'gsap';

export default function Footer() {
  const footerRef = useRef();

  useEffect(() => {
    const handleScroll = () => {
      if (!footerRef.current) return;
      const scrollY = window.scrollY;
      const windowH = window.innerHeight;
      const docH = document.body.scrollHeight;
      const footerTop = footerRef.current.getBoundingClientRect().top + scrollY;
      const progress = Math.min(1, Math.max(0, (scrollY + windowH - footerTop) / windowH));
      gsap.to(footerRef.current, {
        y: -progress * 40,
        opacity: 0.7 + 0.3 * progress,
        duration: 0.5,
        ease: 'power2.out',
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <footer className="footer-futuristic" ref={footerRef}>
      <div className="footer-glow-bg" />
      <div className="footer-content">
        <div className="footer-logo-section">
          <img src="/logo.png" alt="Irod Logo" className="footer-logo" />
          <h2>Irod</h2>
          <p className="footer-tagline">Blending AI, Nature, and the Future</p>
        </div>
        <div className="footer-links-section">
          <h3>Explore</h3>
          <ul>
            <li><a href="#features-section">Features</a></li>
            <li><a href="#about-section">About</a></li>
            <li><a href="#contact-section">Contact</a></li>
            <li><a href="/partner-us">Partner Us</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>
        <div className="footer-wildlife-section">
          <h3>Wildlife Focus</h3>
          <p>Empowering conservation with advanced AI and drone vision.</p>
          <div className="footer-icons">
            <span role="img" aria-label="leaves">🌿</span>
            <span role="img" aria-label="paw">🐾</span>
            <span role="img" aria-label="drone">🛸</span>
            <span role="img" aria-label="chip">💾</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Irod. All rights reserved.</span>
      </div>
    </footer>
  );
}
